import $ from 'jquery';
import { ClientRedirectResponse } from '../../types';

const handle = ({ externalScriptUrl, javaScriptRedirect }: ClientRedirectResponse) => new Promise<void>(() => {
  $.getScript(externalScriptUrl)
    .then(() => {
      const $el = $('<script>');

      $(document.body).append($el);

      $el.html(javaScriptRedirect);
    });
});

export default {
  handle,
};
